import { ReactNode } from 'react';
import styled from 'styled-components';

import InProgressIcon from '#/assets/InProgressIcon';
import SuccessIcon from '#/assets/SuccessIcon';

import { c00EE91, c14142E } from '#/colors';

interface Props {
  readonly icon: ReactNode;
  readonly heading: ReactNode;
  readonly description?: ReactNode;
  readonly isActive: boolean;
  readonly isProgress: boolean;
  readonly isComplete: boolean;
}

export default function Step(props: Props) {
  const { icon, heading, description, isActive, isProgress, isComplete } =
    props;

  function getIndicationIcon(): ReactNode {
    if (isProgress) return <InProgressIcon size={22} />;
    if (isComplete) return <SuccessIndicator />;
    return icon;
  }

  return (
    <Container isActive={isActive}>
      <Indication>{getIndicationIcon()}</Indication>
      <Content>
        <Heading>{heading}</Heading>
        {description != null && <Description>{description}</Description>}
      </Content>
    </Container>
  );
}

const Container = styled.div<{ isActive: boolean }>`
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr;
  gap: 16px;
  padding: 0 12px;

  height: 56px;
  border-radius: 7px;
  background-color: ${c14142E};
  opacity: ${({ isActive }) => (isActive ? 1 : 0.5)};
`;

const Indication = styled.div`
  height: 30px;
  width: 30px;
  display: grid;
  place-items: center;
`;

const SuccessIndicator = styled.div.attrs({
  children: <SuccessIcon size={19} />,
})`
  display: contents;
  color: ${c00EE91};
`;

const Content = styled.div`
  display: grid;
  gap: 8px;
`;

const Heading = styled.h2`
  font-size: 13px;
  font-weight: 700;
  line-height: 13px;
  margin: 0;
`;

const Description = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  opacity: 0.7;
`;
